import PropTypes from 'prop-types';
import { useRouteLoaderData } from 'react-router-dom';
import HealthyDealsDataContextProvider from '../HealthyDealsDataContextProvider/HealthyDealsData.context';
import {
	componentMainTitle,
	componentMainDescription,
} from '../../utils/miscConstants';

// Wrapped component calling the useRouteLoaderData will break the configuration in place in storybook and breaks all tests.
// This way those config are less impacted and this ComponentWrapper serves as feeding the data from Consuming app to diff components.
// Currently there is only one. But it is possible it would wrap more in future
export default function ComponentWrapper({ children }) {
	const {
		redirectToResourceLibrary,
		ssId,
		redirectToLogin,
		redirectToNetworkSearch,
		setMainTitleTo = componentMainTitle,
		description = componentMainDescription,
		updatePageTitleAndDescription,
		componentRootPath,
	} = useRouteLoaderData('healthyDealsRoutesData');

	return (
		<HealthyDealsDataContextProvider
			redirectToResourceLibrary={redirectToResourceLibrary}
			isUserAuthenticated={!!ssId} // ssId will determine if the user is authenticated or not
			redirectToLogin={redirectToLogin}
			redirectToNetworkSearch={redirectToNetworkSearch}
			setMainTitleTo={setMainTitleTo}
			description={description}
			updatePageTitleAndDescription={updatePageTitleAndDescription}
			componentRootPath={componentRootPath}
		>
			{children}
		</HealthyDealsDataContextProvider>
	);
}

ComponentWrapper.propTypes = {
	children: PropTypes.node.isRequired,
};
